export enum ResponsiveMenuMode {
  Dropdown = 'dropdown',
  Drawer = 'drawer'
}
